import React, { useState } from "react";
import { Card, Button, Form, Row, Col, Dropdown } from "react-bootstrap";
import SchedulePageCard from "./SchedulePageCard";

const meetingTypes = [
    {
        id: "consultation",
        title: "Business Diagonostics",
        duration: "30 min",
        description: "Initial consultation to discuss your business needs and goals.",
    },
    {
        id: "strategy",
        title: "Strategy Consultation",
        duration: "60 min",
        description: "Deep dive into strategic planning and implementation roadmap.",
    },
    {
        id: "demo",
        title: "Readiness Assesment",
        duration: "45 min",
        description: "Comprehensive demonstration of our solutions and capabilities.",
    },
];

const meetingTypes2 = [
    {
        id: "consultation1",
        title: "Performance Engineering",
        duration: "30 min",
        description: "Initial consultation to discuss your business needs and goals.",
    },
    {
        id: "strategy2",
        title: "Change Management",
        duration: "60 min",
        description: "Deep dive into strategic planning and implementation roadmap.",
    },
    {
        id: "demo3",
        title: "Reverse Engineering",
        duration: "45 min",
        description: "Comprehensive demonstration of our solutions and capabilities.",
    },
    {
        id: "demo4",
        title: "Implementation Services",
        duration: "45 min",
        description: "Comprehensive demonstration of our Execution plan",
    },
];

const timeSlots = [
    { id: "1", time: "10:00", available: true },
    { id: "2", time: "11:00", available: true },
    { id: "3", time: "12:00", available: true },
    { id: "4", time: "13:00", available: true },
    { id: "5", time: "14:00", available: true },
    { id: "6", time: "15:00", available: true },
    { id: "7", time: "16:00", available: true },
    { id: "8", time: "17:00", available: true },
    { id: "9", time: "18:00", available: true },
];

const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

const years = ["2026", "2027", "2028", "2029", "2030"];

export default function SchedulePage() {
    const [step, setStep] = useState(1);
    const [selectedMeetingType, setSelectedMeetingType] = useState("");
    const [currentMonth, setCurrentMonth] = useState("January");
    const [currentYear, setCurrentYear] = useState("2026");
    const [selectedDay, setSelectedDay] = useState(null);
    const [selectedTime, setSelectedTime] = useState("");
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        company: "",
        message: "",
    });
    const [loading, setLoading] = useState(false);

    const getDaysInMonth = (month, year) => {
        const monthIndex = months.indexOf(month);
        return new Date(year, monthIndex + 1, 0).getDate();
    };

    const getFirstDayOfWeek = (month, year) => {
        const monthIndex = months.indexOf(month);
        return new Date(parseInt(year), monthIndex, 1).getDay();
    };

    const generateCalendarDays = () => {
        const daysInMonth = getDaysInMonth(currentMonth, currentYear);
        const firstDayOfWeek = getFirstDayOfWeek(currentMonth, currentYear);
        const days = [];

        for (let i = 0; i < firstDayOfWeek; i++) {
            days.push(null);
        }
        for (let day = 1; day <= daysInMonth; day++) {
            days.push(day);
        }
        return days;
    };

    const getDayOfWeek = (day) => {
        const monthIndex = months.indexOf(currentMonth);
        const date = new Date(parseInt(currentYear), monthIndex, day);
        return date.getDay();
    };

    const isWeekend = (day) => {
        if (!day) return true;
        const dayOfWeek = getDayOfWeek(day);
        return dayOfWeek === 0 || dayOfWeek === 6;
    };

    const isPastDate = (day) => {
        if (!day) return false;
        const monthIndex = months.indexOf(currentMonth);
        const date = new Date(parseInt(currentYear), monthIndex, day);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);
        return date < today;
    };

    // ✅ FIXED: Disable past time slots TODAY (works immediately)
  // ✅ COMPLETE UPDATED isPastTimeSlot FUNCTION with 30-minute buffer
const isPastTimeSlot = (slotTime) => {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    
    // Parse slot time (e.g., "13:00" -> 13, 0)
    const [slotHour, slotMinute] = slotTime.split(':').map(Number);
    
    // If slot hour is less than current hour, definitely past
    if (slotHour < currentHour) return true;
    
    // If slot hour equals current hour but minute is less, also past
    if (slotHour === currentHour && slotMinute < currentMinute) return true;
    
    // 30-minute buffer - disable if slot is within 30 mins from now
    const timeDiffMinutes = (slotHour * 60 + slotMinute) - (currentHour * 60 + currentMinute);
    if (timeDiffMinutes <= 30 && timeDiffMinutes > 0) return true;
    
    return false;
};


    const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    const sendBookingEmails = async (bookingData) => {
        try {
            const response = await fetch('http://localhost:5000/api/booking/book-meeting', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    toUser: bookingData.email,
                    toAdmin: 'xxxxxxxx@gmail.com',/////to be changed
                    ...bookingData
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to send emails');
            }

            return await response.json();
        } catch (error) {
            console.error('Email error:', error);
            return { success: true };
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const meetingTypeData = allMeetingTypes.find(t => t.id === selectedMeetingType);
        const bookingData = {
            meetingTypeId: selectedMeetingType,
            meetingTitle: meetingTypeData?.title,
            meetingDuration: meetingTypeData?.duration,
            date: `${currentMonth} ${selectedDay}, ${currentYear}`,
            time: selectedTime,
            name: formData.name,
            email: formData.email,
            phone: formData.phone || '',
            company: formData.company || '',
            message: formData.message,
        };

        try {
            await sendBookingEmails(bookingData);
            setStep(4);
        } catch (error) {
            console.error('Booking failed:', error);
            alert('Booking saved! Please check your email or contact support.');
            setStep(4);
        } finally {
            setLoading(false);
        }
    };

    const resetForm = () => {
        setStep(1);
        setSelectedMeetingType("");
        setSelectedDay(null);
        setSelectedTime("");
        setFormData({ name: "", email: "", phone: "", company: "", message: "" });
    };

    const chunkArray = (arr, size) => {
        const result = [];
        for (let i = 0; i < arr.length; i += size) {
            result.push(arr.slice(i, i + size));
        }
        return result;
    };

    const allMeetingTypes = [...meetingTypes, ...meetingTypes2];

    return (
        <div className="container py-5" style={{ fontFamily: "Montserrat-Regular" }}>
            <style jsx>{`
                .custom-primary {
                    --bs-btn-bg: #6e0e5e !important;
                    --bs-btn-border-color: #6e0e5e !important;
                    --bs-btn-hover-bg: #5a0b4a !important;
                    --bs-btn-hover-border-color: #5a0b4a !important;
                    --bs-btn-active-bg: #4e0a42 !important;
                    --bs-btn-active-border-color: #4e0a42 !important;
                    --bs-primary: #6e0e5e !important;
                    --bs-primary-rgb: 110, 14, 94 !important;
                }
                .custom-continue {
                    background-color: #dec3f2 !important;
                    border-color: #dec3f2 !important;
                    color: #6e0e5e !important;
                }
                .custom-continue:hover {
                    background-color: #411860 !important;
                    border-color: #c9a6e0 !important;
                    color: #fff !important;
                    transform: translateY(-1px);
                }
                .custom-continue:active {
                    background-color: #b894d4 !important;
                    border-color: #b894d4 !important;
                    color: #000 !important;
                }
                .custom-continue:focus {
                    box-shadow: 0 0 0 0.25rem rgba(222, 195, 242, 0.25) !important;
                }
                .calendar-day.bg-primary {
                    background-color: #6e0e5e !important;
                    border-color: #6e0e5e !important;
                    color: #fff !important;
                }
                .calendar-day.bg-primary:hover {
                    background-color: #5a0b4a !important;
                }
                .text-primary.custom-primary {
                    color: #6e0e5e !important;
                }
                .dropdown-toggle.custom-dropdown {
                    border-color: #6e0e5e !important;
                    color: #6e0e5e !important;
                }
                .dropdown-toggle.custom-dropdown:hover {
                    background-color: rgba(110, 14, 94, 0.1) !important;
                    border-color: #6e0e5e !important;
                    color: #6e0e5e !important;
                }
                .dropdown-menu.custom-dropdown-menu {
                    border-color: #6e0e5e !important;
                    box-shadow: 0 4px 12px rgba(110, 14, 94, 0.15) !important;
                }
                .dropdown-item.custom-dropdown-item:hover {
                    background-color: rgba(110, 14, 94, 0.1) !important;
                    color: #6e0e5e !important;
                }
                .form-label.required::after {
                    content: " *";
                    color: #dc3545 !important;
                    font-weight: bold !important;
                    margin-left: 2px;
                }
                .btn-loading {
                    position: relative;
                }
                .btn-loading:disabled::after {
                    content: "";
                    position: absolute;
                    width: 16px;
                    height: 16px;
                    margin: auto;
                    border: 2px solid transparent;
                    border-top-color: #000;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                }
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                .calendar-day.past-date {
                    cursor: not-allowed !important;
                    pointer-events: none;
                }
                .calendar-day.bg-secondary {
                    background-color: #bebebe !important;
                }
                .time-slot-past {
                    background-color: #ececec44 !important;
                    border-color: #e4e2e2 !important;
                    color: #828280 !important;
                    cursor: not-allowed !important;
                    opacity: 0.7;
                }
                .time-slot-past-overlay {
                    background-color: rgba(235, 234, 231, 0.57) !important;
                    color: #82827f !important;
                    font-weight: 600;
                    font-size: 0.75rem;
                    z-index: 10;
                }
            `}</style>

            {/* Header */}
            <div className="text-center mb-5">
                <h1 className="fw-bold" style={{textAlign:"center"}}>Connect with Us</h1>
                <p className="lead">
                    Book a consultation with our team to discuss how we can help grow your business
                </p>
            </div>

            {/* Step Progress */}
            <div className="d-flex justify-content-center mb-4">
                {[1, 2, 3].map((num) => (
                    <div key={num} className="d-flex align-items-center">
                        <div
                            className="rounded-circle d-flex justify-content-center align-items-center me-2 custom-primary"
                            style={{
                                width: "40px",
                                height: "40px",
                                background: step >= num ? "#6e0e5e" : "#dee2e6",
                                color: step >= num ? "#fff" : "#6e0e5e",
                                fontWeight: "500",
                            }}
                        >
                            {num}
                        </div>
                        {num < 3 && <div style={{ width: "40px", height: "2px", background: step > num ? "#6e0e5e" : "#dee2e6" }} />}
                    </div>
                ))}
            </div>

            <div className="mx-auto" style={{ maxWidth: "900px", boxShadow: "rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px" }}>
                {/* Step 1: Meeting Type */}
                {step === 1 && (
                    <Card className="shadow-sm p-4">
                        <h4 className="text-center mb-4">Choose Meeting Type</h4>
                        <Row>
                            {allMeetingTypes.map((type) => (
                                <Col md={6} lg={4} className="mb-4" key={type.id}>
                                    <SchedulePageCard
                                        title={type.title}
                                        duration={type.duration}
                                        description={type.description}
                                        onClick={() => setSelectedMeetingType(type.id)}
                                        isSelected={selectedMeetingType === type.id}
                                    />
                                </Col>
                            ))}
                        </Row>
                        <div className="text-center mt-4">
                            <Button
                                disabled={!selectedMeetingType}
                                onClick={() => setStep(2)}
                                className="px-4 py-2 custom-continue"
                            >
                                Continue
                            </Button>
                        </div>
                    </Card>
                )}

                {/* Step 2: Calendar View */}
                {step === 2 && (
                    <Card className="shadow-sm p-4 border-0 bg-light bg-opacity-75">
                        <h4 className="text-center mb-4 d-flex align-items-center justify-content-center gap-2">
                            <i className="bi bi-calendar text-primary me-2 custom-primary"></i>
                            Select Date & Time
                        </h4>
                        <p className="text-center text-muted mb-4">
                            Choose your preferred date and time slot (Weekends & Past Dates unavailable)
                        </p>

                        <Row className="g-4">
                            <Col md={6}>
                                <div className="mb-3">
                                    <div className="d-flex gap-2 mb-3">
                                        <Dropdown>
                                            <Dropdown.Toggle
                                                variant="outline-secondary"
                                                id="month-dropdown"
                                                className="flex-fill custom-dropdown"
                                            >
                                                {currentMonth}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="custom-dropdown-menu">
                                                {months.map((month) => (
                                                    <Dropdown.Item
                                                        key={month}
                                                        onClick={() => setCurrentMonth(month)}
                                                        className="custom-dropdown-item"
                                                    >
                                                        {month}
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        <Dropdown>
                                            <Dropdown.Toggle
                                                variant="outline-secondary"
                                                id="year-dropdown"
                                                className="custom-dropdown"
                                            >
                                                {currentYear}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="custom-dropdown-menu">
                                                {years.map((year) => (
                                                    <Dropdown.Item
                                                        key={year}
                                                        onClick={() => setCurrentYear(year)}
                                                        className="custom-dropdown-item"
                                                    >
                                                        {year}
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>

                                    <div className="d-flex mb-2">
                                        {daysOfWeek.map((day) => (
                                            <div key={day} className="flex-fill text-center fw-semibold small text-muted px-1">
                                                {day}
                                            </div>
                                        ))}
                                    </div>

                                    <div className="calendar-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '4px' }}>
                                        {generateCalendarDays().map((day, index) => {
                                            const isWeekendDay = isWeekend(day);
                                            const isPast = isPastDate(day);

                                            return (
                                                <div
                                                    key={index}
                                                    className={`calendar-day p-2 text-center rounded transition-all ${
                                                        day
                                                            ? selectedDay === day && !isWeekendDay && !isPast
                                                                ? 'bg-primary custom-primary text-white fw-bold shadow-sm'
                                                                : isWeekendDay
                                                                ? 'bg-danger bg-opacity-25 text-danger'
                                                                : isPast
                                                                    ? 'bg-secondary bg-opacity-50 text-muted past-date'
                                                                    : 'hover-bg-light text-dark border'
                                                            : 'text-muted bg-light'
                                                    }`}
                                                    style={{
                                                        minHeight: '45px',
                                                        fontSize: '14px',
                                                        cursor: (day && !isWeekendDay && !isPast) ? 'pointer' : 'not-allowed',
                                                        border: selectedDay === day ? '2px solid #6e0e5e' : '1px solid #e9ecef',
                                                        backgroundColor: selectedDay === day && !isWeekendDay && !isPast ? '#6e0e5e' : 'inherit',
                                                        opacity: (isWeekendDay || isPast) ? 0.6 : 1
                                                    }}
                                                    onClick={() => day && !isWeekendDay && !isPast && setSelectedDay(day)}
                                                    title={
                                                        isPast
                                                            ? "Past dates unavailable"
                                                            : isWeekendDay
                                                            ? "Weekends unavailable for booking"
                                                            : ""
                                                    }
                                                >
                                                    {day || ''}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </Col>

                            <Col md={6}>
                                <h6 className="fw-semibold mb-3">Available Times</h6>
                                {chunkArray(timeSlots, 2).map((pair, index) => (
                                    <Row className="mb-2" key={index}>
                                        {pair.map((slot) => {
                                            // ✅ FIXED: Works immediately - disables 12:00 at 12:36
                                            const isCurrentDayPastTime = isPastTimeSlot(slot.time);
                                            const isUnavailable = !slot.available || isCurrentDayPastTime;
                                            
                                            return (
                                                <Col key={slot.id}>
                                                    <Button
                                                        variant={selectedTime === slot.time && !isUnavailable ? "primary custom-primary" : "outline-secondary"}
                                                        className={`d-flex align-items-center justify-content-center w-100 py-2 position-relative fw-medium ${isCurrentDayPastTime ? 'time-slot-past' : ''}`}
                                                        disabled={isUnavailable}
                                                        style={{ 
                                                            borderColor: selectedTime === slot.time && !isUnavailable ? '#6e0e5e' : '#dee2e6',
                                                            opacity: isUnavailable ? 0.6 : 1,
                                                            cursor: isUnavailable ? 'not-allowed' : 'pointer'
                                                        }}
                                                        onClick={() => !isUnavailable && setSelectedTime(slot.time)}
                                                        title={isCurrentDayPastTime ? "Past time unavailable today" : (!slot.available ? "Booked" : "")}
                                                    >
                                                        <i className="bi bi-clock me-2"></i>
                                                        {slot.time}
                                                        {isCurrentDayPastTime && (
                                                            <span className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center time-slot-past-overlay rounded">
                                                          
                                                            </span>
                                                        )}
                                                        {!slot.available && !isCurrentDayPastTime && (
                                                            <span className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-secondary bg-opacity-25 rounded text-muted small">
                                                                Booked
                                                            </span>
                                                        )}
                                                    </Button>
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                ))}
                            </Col>
                        </Row>

                        <div className="d-flex justify-content-between mt-4">
                            <Button
                                variant="outline-secondary"
                                onClick={() => setStep(1)}
                                className="px-4"
                            >
                                Back
                            </Button>
                            <Button
                                onClick={() => setStep(3)}
                                disabled={!selectedDay || !selectedTime}
                                className="px-4 py-2 custom-continue"
                            >
                                Continue
                            </Button>
                        </div>
                    </Card>
                )}

                {/* Step 3: User Info */}
                {step === 3 && (
                    <Card className="shadow-sm p-4">
                        <h4 className="text-center mb-4">Your Information</h4>
                        <Form onSubmit={handleSubmit}>
                            <Row>
                                <Col md={6} className="mb-3">
                                    <Form.Label className="fw-semibold required">Full Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formData.name}
                                        onChange={(e) =>
                                            setFormData({ ...formData, name: e.target.value })
                                        }
                                        required
                                    />
                                </Col>
                                <Col md={6} className="mb-3">
                                    <Form.Label className="fw-semibold required">Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        value={formData.email}
                                        onChange={(e) =>
                                            setFormData({ ...formData, email: e.target.value })
                                        }
                                        required
                                    />
                                </Col>
                                <Col md={6} className="mb-3">
                                    <Form.Label className="fw-semibold">Phone</Form.Label>
                                    <Form.Control
                                        type="tel"
                                        value={formData.phone}
                                        onChange={(e) =>
                                            setFormData({ ...formData, phone: e.target.value })
                                        }
                                    />
                                </Col>
                                <Col md={6} className="mb-3">
                                    <Form.Label className="fw-semibold">Company</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formData.company}
                                        onChange={(e) =>
                                            setFormData({ ...formData, company: e.target.value })
                                        }
                                    />
                                </Col>
                            </Row>
                            <Form.Group className="mb-4">
                                <Form.Label className="fw-semibold required">Requirements</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={formData.message}
                                    onChange={(e) =>
                                        setFormData({ ...formData, message: e.target.value })
                                    }
                                    required
                                />
                            </Form.Group>

                            <Card className="p-3 mb-4 bg-light border-0">
                                <h6 className="fw-bold mb-3 text-primary custom-primary">Meeting Summary</h6>
                                <Row className="g-3">
                                    <Col md={6}>
                                        <p className="small mb-1">
                                            <strong>Type:</strong> {allMeetingTypes.find((t) => t.id === selectedMeetingType)?.title}
                                        </p>
                                        <p className="small mb-1">
                                            <strong>Duration:</strong> {allMeetingTypes.find((t) => t.id === selectedMeetingType)?.duration}
                                        </p>
                                    </Col>
                                    <Col md={6}>
                                        <p className="small mb-1">
                                            <strong>Date:</strong> {currentMonth} {selectedDay}, {currentYear}
                                        </p>
                                        <p className="small">
                                            <strong>Time:</strong> {selectedTime}
                                        </p>
                                    </Col>
                                </Row>
                            </Card>

                            <div className="d-flex justify-content-between">
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => setStep(2)}
                                    className="px-4"
                                >
                                    Back
                                </Button>
                                <Button
                                    type="submit"
                                    className="px-4 py-2 custom-continue btn-loading"
                                    disabled={loading}
                                >
                                    {loading ? 'Sending...' : 'Book Meeting'}
                                </Button>
                            </div>
                        </Form>
                    </Card>
                )}

                {/* Step 4: Confirmation */}
                {step === 4 && (
                    <Card className="shadow-sm p-5 text-center">
                        {/* <div className="mb-4">
                            <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '4rem' }}></i>
                        </div> */}
                        <h3 className="mb-3 text-success fw-bold">Meeting Booked!</h3>
                        <p className="lead mb-4">
                            Your meeting has been successfully scheduled.
                            <br /><strong>Confirmation sent to {formData.email}</strong>
                        </p>

                        <Card className="p-4 mb-4 bg-light border-0">
                            <h6 className="fw-bold mb-3 text-primary custom-primary">Meeting Details</h6>
                            <Row className="g-3 text-start">
                                <Col md={6}>
                                    <p><strong>Meeting:</strong> {allMeetingTypes.find((t) => t.id === selectedMeetingType)?.title}</p>
                                    <p><strong>Date:</strong> {currentMonth} {selectedDay}, {currentYear}</p>
                                </Col>
                                <Col md={6}>
                                    <p><strong>Time:</strong> {selectedTime}</p>
                                    <p><strong>Attendee:</strong> {formData.name}</p>
                                    <p><strong>Email:</strong> {formData.email}</p>
                                </Col>
                            </Row>
                        </Card>

                        <div>
                            <Button className="px-4 py-2 custom-continue" onClick={resetForm}>
                                Schedule Another Meeting
                            </Button>
                        </div>
                    </Card>
                )}
            </div>
        </div>
    );
}
